// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__J75Gc","item__menu":"menu_item__menu__viRx6"};